import React from 'react'
import { Link } from 'react-router-dom'

export default function BranchButton({ variant = 'primary', to, onClick, children, className = '', style, loading, disabled, ...rest }) {
  const isDisabled = loading || disabled
  const cls = `branch-btn branch-btn-${variant} ${loading ? 'branch-btn-loading' : ''} ${className}`.trim()

  if (to) {
    return (
      <Link to={to} className={cls} style={style} {...rest}>
        {children}
      </Link>
    )
  }

  return (
    <button className={cls} onClick={onClick} style={style} disabled={isDisabled} {...rest}>
      {loading && <span className='branch-btn-spinner' />}
      {loading ? 'Saving...' : children}
    </button>
  )
}
